var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/TreeView.tsx
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { jsx } from "react/jsx-runtime";
var TreeView = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx(SimpleTreeView, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/DynamicTreeView.tsx
import { RichTreeView } from "@mui/x-tree-view/RichTreeView";

// src/lib/TreeItem.tsx
import { TreeItem2 } from "@mui/x-tree-view/TreeItem2";
import { TriangleRightIcon, TriangleExpandIcon } from "@availity/mui-icon";
import { jsx as jsx2 } from "react/jsx-runtime";
var TreeItem = (_a) => {
  var _b = _a, { children, label, slots, slotProps, truncate } = _b, rest = __objRest(_b, ["children", "label", "slots", "slotProps", "truncate"]);
  return /* @__PURE__ */ jsx2(
    TreeItem2,
    __spreadProps(__spreadValues({}, rest), {
      label,
      slots: __spreadProps(__spreadValues({}, slots), {
        expandIcon: TriangleRightIcon,
        collapseIcon: TriangleExpandIcon
      }),
      slotProps: __spreadProps(__spreadValues({}, slotProps), {
        expandIcon: { fontSize: "Xsmall" },
        collapseIcon: { fontSize: "Xsmall" },
        label: {
          style: truncate ? { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } : {}
        },
        checkbox: {
          // @ts-expect-error TreeItem2SlotProps.checkbox types are incorrect
          inputProps: {
            "aria-hidden": true
          }
        }
      }),
      children
    })
  );
};

// src/lib/DynamicTreeView.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var DynamicTreeView = (_a) => {
  var _b = _a, { children, slots } = _b, rest = __objRest(_b, ["children", "slots"]);
  return /* @__PURE__ */ jsx3(RichTreeView, __spreadProps(__spreadValues({}, rest), { slots: __spreadProps(__spreadValues({}, slots), { item: TreeItem }), children }));
};

// src/lib/JsonViewer.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var isPrimitive = (value) => {
  return ["string", "number", "boolean"].includes(typeof value);
};
var isObject = (value) => {
  return !!value && typeof value === "object";
};
var validateId = (id) => id.replace(/[^.\w:-]+/gi, "");
var getDetails = ({ data }, parentKey) => {
  return Object.entries(data).map(([key, value], index) => {
    const id = validateId(parentKey ? `${parentKey}.${index}.${key}` : `${index}.${key}`);
    if (isPrimitive(value)) {
      const label = `${key}: ${value.toString()}`;
      return /* @__PURE__ */ jsx4(TreeItem, { label, itemId: id }, id);
    }
    if (isObject(value)) {
      const label = `${key}: ${Array.isArray(value) ? `[ ] ${value.length} items` : `{ } ${Object.keys(value).length} keys`}`;
      return /* @__PURE__ */ jsx4(TreeItem, { label, itemId: id, children: getDetails({ data: value }, id) }, id);
    }
    return null;
  });
};
var JsonViewer = (_a) => {
  var _b = _a, { data } = _b, rest = __objRest(_b, ["data"]);
  const details = getDetails({ data });
  return /* @__PURE__ */ jsx4(TreeView, __spreadProps(__spreadValues({}, rest), { children: details }));
};
export {
  DynamicTreeView,
  JsonViewer,
  TreeItem,
  TreeView
};
